import React, { useEffect } from 'react';

import { Button, Col, Divider, Modal, Row, Select } from 'antd';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getReportTypeList } from '../../../data/store/portfolio/portfolioActions';
import { CLEAR_REPORT_TYPE_LIST } from '../../../data/store/portfolio/portfolioActionTypes';
import CustomSelect from '../../../components/CustomSelect/CustomSelect';

const ModalCreateReport = ({
  modalFinishVisible,
  closeFinishModal,
  cancelWithoutReport,
  handleSaveReport,
  reportType,
  setReportType,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('');
  const { reportTypeList } = useSelector((state) => state.portfolioReducer);

  useEffect(() => {
    if (modalFinishVisible) {
      dispatch(getReportTypeList());
    }
    return () => {
      dispatch({ type: CLEAR_REPORT_TYPE_LIST.ACTION });
    };
  }, [modalFinishVisible]);

  useEffect(() => {
    console.log('🚀 ~ ModalCreateReport ~ reportType:', reportType);
  }, [reportType]);

  const handleSelect = (value) => {
    console.log('🚀 ~ handleSelect ~ value:', value);
    setReportType(value);
  };

  return (
    <Modal
      width={700}
      className="modal-content-paper"
      open={modalFinishVisible}
      onCancel={closeFinishModal}
      footer={null}
      zIndex={1620}
    >
      <Row justify="start">
        <Col className="modal-title">{t('WARNING_OPT')}</Col>
      </Row>
      <Divider className="modal-divider" />
      <Row justify="start" className="modal-text-wrapper select-type">
        <Col span={18}>
          <p className="modal-description">{t('REPORT_TEXT')}</p>
        </Col>
      </Row>
      <Divider className="modal-divider" />
      <h3 className="modal-description-type">{t('REPORT_TEXT_TYPE')}</h3>
      {reportTypeList && (
        <CustomSelect
          width="100%"
          className="custom-select"
          onSelect={(value) => handleSelect(value)}
          value={reportType}
        >
          {reportTypeList.map((el) => (
            <Select.Option key={el.id} value={el.id}>
              {el.name}
            </Select.Option>
          ))}
        </CustomSelect>
      )}
      <Row justify="end" style={{ marginTop: '50px' }}>
        <Col>
          <Button
            className="modal-action-btn cancel-btn"
            onClick={cancelWithoutReport}
          >
            {t('CANCEL')}
          </Button>
          <Button
            disabled={!reportType}
            style={{ marginLeft: '8px' }}
            className="modal-action-btn save-btn"
            onClick={handleSaveReport}
          >
            {t('CREATE_REPORT')}
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default ModalCreateReport;

ModalCreateReport.propTypes = {
  modalFinishVisible: PropTypes.bool,
  closeFinishModal: PropTypes.func,
  cancelWithoutReport: PropTypes.func,
  handleSaveReport: PropTypes.func,
  reportType: PropTypes.string,
  setReportType: PropTypes.func,
};
